module.exports = __webpack_public_path__ + "img/Canons_a_confettis_pour_mariage.bf1b435.jpg";